import React, { Fragment } from 'react';
import VehiclePhoto from '../formSection/Fields/VehiclePhoto';
import {
  UPLOAD_VEHICLE_STS_FRONT,
  UPLOAD_VEHICLE_PTS_FRONT,
  UPLOAD_VEHICLE_STS_BACK,
  UPLOAD_VEHICLE_PTS_BACK,
} from '../../../api/constants';

const Section9 = ({ disabled, form, vehicleId }) => {
  return (
    <Fragment>
      <div className="border-emmit" />
      <div className="aHeight-3" />
      <div className="wrapNinePhoto">
        <div className="upload-element">
          <span className="column-title">
            Фотография лицевой стороны свидетельства о регистрации ТС (СТС):
          </span>
          <VehiclePhoto
            form={form}
            disabled={disabled}
            name={`photoFrontSts`}
            data={{ vehicle_id: vehicleId }}
            action={
              vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_STS_FRONT : null
            }
          />
        </div>
        <div className="upload-element">
          <span className="column-title">
            Фотография лицевой стороны паспорта ТС (ПТС):
          </span>
          <VehiclePhoto
            form={form}
            disabled={disabled}
            name={`photoFrontPts`}
            data={{ vehicle_id: vehicleId }}
            action={
              vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_PTS_FRONT : null
            }
          />
        </div>
        <div className="upload-element">
          <span className="column-title">
            Фотография оборотной стороны свидетельства о регистрации ТС (СТС):
          </span>
          <VehiclePhoto
            form={form}
            disabled={disabled}
            name={`photoBackSts`}
            data={{ vehicle_id: vehicleId }}
            action={vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_STS_BACK : null}
          />
        </div>
        <div className="upload-element">
          <span className="column-title">
            Фотография оборотной стороны паспорта ТС (ПТС):
          </span>
          <VehiclePhoto
            form={form}
            disabled={disabled}
            name={`photoBackPts`}
            data={{ vehicle_id: vehicleId }}
            action={vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_PTS_BACK : null}
          />
        </div>
      </div>
      <div className="aHeight-3" />
    </Fragment>
  );
};

export default Section9;
